<template>
  <b-form @submit.prevent>
    <b-form-group
      :invalid-feedback="invalidFeedback"
      :state="state"
    >
      <b-form-input
        @keyup.enter="$event.target.blur()"
        @focus="$v.localValue.$touch()"
        @blur="updateCell"
        @input="setValue"
        :state="state"
        :value="value"
      />
    </b-form-group>
  </b-form>
</template>

<script>

  import { asciiOnlyValidator, decimalValidator, flexposBarcodeValidator, noSpecialHtmlCharsValidator } from '@base/customValidators'
  import {
    PRODUCT_NAME_MAX_LENGTH,
    PRODUCT_DESCRIPTION_MAX_LENGTH,
    PRODUCT_BARCODE_MAX_LENGTH,
  } from '@base/configs'
  import { maxLength } from 'vuelidate/lib/validators'

  const FIELD_LABELS = {
    name: 'form.products.name_field',
    originalPrice: 'form.products.price_field',
    description: 'form.products.description',
    barcode: 'form.products.barcode',
  }

  export default {
    name: 'ProductSheetCellInput',

    data () {
      return {
        localValue: this.value,
      }
    },

    props: {
      value: {
        type: [String, Number],
        default: null
      },
      field: {
        type: String,
        required: true
      },
      isFlexposMarket: {
        type: Boolean,
        default: false
      },
    },

    validations () {
      const fieldRules = {
        name: {
          maxLength: maxLength(PRODUCT_NAME_MAX_LENGTH),
          noSpecialHtmlCharsValidator,
        },
        originalPrice: {
          decimal: decimalValidator
        },
        description: {
          maxLength: maxLength(PRODUCT_DESCRIPTION_MAX_LENGTH),
          noSpecialHtmlCharsValidator,
        },
        barcode: {
          maxLength: maxLength(PRODUCT_BARCODE_MAX_LENGTH),
          noSpecialHtmlCharsValidator,
          asciiOnlyValidator,
          ...(this.isFlexposMarket && { flexposBarcodeValidator }),
        },
      }
      return {
        localValue: fieldRules[this.field]
      }
    },

    computed: {
      state () {
        return this.$v.localValue.$error ? false : null
      },

      invalidFeedback () {
        const validation = this.$v.localValue
        if (!validation.$error)
          return null
        const fieldLabel = this.$t(FIELD_LABELS[this.field])
        if (validation.maxLength === false)
          return this.$t('validation.max_length', {
            field: fieldLabel,
            maxLength: validation.$params.maxLength.max
          })
        else if (validation.noSpecialHtmlCharsValidator === false)
          return this.$t('validation.special_chars_not_allowed', { field: fieldLabel })
        else if (validation.asciiOnlyValidator === false)
          return this.$t('validation.ascii_only', { field: fieldLabel })
        else if (validation.flexposBarcodeValidator === false)
          return this.$t('validation.flexpos_barcode')
        else if (validation.decimal === false)
          return this.$t('validation.decimal', { field: fieldLabel })
        return null
      },
    },

    watch: {
      value (newValue) {
        if (newValue === this.localValue)
          return
        this.localValue = newValue
        if (this.$v.localValue.$dirty)
          this.$emit('cellUpdated', { value: newValue, invalid: this.$v.localValue.$invalid })
      },
    },

    methods: {
      setValue (value) {
        this.localValue = value
        this.$v.localValue.$touch()
      },

      updateCell () {
        this.$v.localValue.$touch()
        const invalid = this.$v.localValue.$invalid
        if (this.localValue === this.value && !invalid)
          return
        this.$emit('cellUpdated', { value: this.localValue, invalid })
      },
    },
  }

</script>
